import React from 'react';
import { useState } from 'react';
import { Container, Wrapper, Title, Desc, CardContainer, ToggleButtonGroup, ToggleButton, Divider, NoProjects } from './ProjectsStyle';
import ProjectCard from '../Cards/ProjectCards';
import { projects } from '../../data/constants';

const Projects = ({ openModal, setOpenModal }) => {
  const [toggle, setToggle] = useState('all');

  const filteredProjects = toggle === 'all'
    ? projects
    : projects.filter((item) => item.category === toggle);

  return (
    <Container id="projects">
      <Wrapper>
        <Title className="cursor-scale">Projects</Title>
        <Desc className="cursor-scale">
          Showcase of my web and mobile application development projects.
        </Desc>
        <ToggleButtonGroup>
          {toggle === 'all' ? (
            <ToggleButton active value="all" onClick={() => setToggle('all')}>
              ALL
            </ToggleButton>
          ) : (
            <ToggleButton value="all" onClick={() => setToggle('all')}>
              ALL
            </ToggleButton>
          )}
          <Divider />
          {toggle === 'full stack' ? (
            <ToggleButton active value="web app" onClick={() => setToggle('full stack')}>
              FULL STACK
            </ToggleButton>
          ) : (
            <ToggleButton value="web app" onClick={() => setToggle('full stack')}>
              FULL STACK
            </ToggleButton>
          )}
          <Divider className="cursor-scale" />
          {toggle === 'mobile app' ? (
            <ToggleButton active value="mobile app" onClick={() => setToggle('mobile app')}>
              MOBILE APPS
            </ToggleButton>
          ) : (
            <ToggleButton value="mobile app" onClick={() => setToggle('mobile app')}>
              MOBILE APPS
            </ToggleButton>
          )}
          <Divider />
          {toggle === 'frontend' ? (
            <ToggleButton active value="frontend" onClick={() => setToggle('frontend')}>
              FRONTEND
            </ToggleButton>
          ) : (
            <ToggleButton value="frontend" onClick={() => setToggle('frontend')}>
              FRONTEND
            </ToggleButton>
          )}
          <Divider />
          {toggle === 'design prototype' ? (
            <ToggleButton active value="design prototype" onClick={() => setToggle('design prototype')}>
              DESIGN
            </ToggleButton>
          ) : (
            <ToggleButton value="design prototype" onClick={() => setToggle('design prototype')}>
              DESIGN
            </ToggleButton>
          )}
        </ToggleButtonGroup>
        <CardContainer>
          {filteredProjects.length > 0 ? (
            filteredProjects.map((project) => (
              <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal} key={project.id} />
            ))
          ) : (
            <NoProjects>No items available yet</NoProjects>
          )}
        </CardContainer>
      </Wrapper>
    </Container>
  );
};

export default Projects;
